module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3Qm4h"))).then(() => parcelRequire('dJXJK'));